import {useEffect,useRef,useState} from "react";
export default function PresenceDetector({camera,video,onEvent}){
 const [enabled,setEnabled]=useState(false),[presence,setPresence]=useState(null),[error,setError]=useState("");
 const callback=useRef(onEvent);callback.current=onEvent;
 useEffect(()=>{
  if(!enabled||!camera){setPresence(null);return;}
  let alive=true,ready=false,busy=false,timer=null,timeout=null,worker=null,detector=null,fallbackStarted=false,streak=0,last=null;
  const base=(process.env.PUBLIC_URL||"")+"/vision";
  setError("");
  const stop=()=>{alive=false;clearInterval(timer);clearTimeout(timeout);worker?.terminate();detector?.close();};
  const fail=message=>{if(alive){setError(message);setEnabled(false);stop();}};
  const result=count=>{
   if(!alive)return;
   busy=false;const detected=count>0;
   streak=detected===last?streak+1:1;last=detected;
   if(streak>=3){setPresence(detected);callback.current?.("person_presence",detected?1:0);}
  };
  const fallback=async()=>{
   if(!alive||fallbackStarted)return;fallbackStarted=true;ready=false;busy=false;worker?.terminate();worker=null;
   clearTimeout(timeout);timeout=setTimeout(()=>fail("La detección local no respondió."),30000);
   try{
    // WebKit may need a document-backed canvas. In that case infer at most once per 3 seconds.
    const engine=await import(/* webpackIgnore: true */ base+"/person-engine.mjs");
    const local=await engine.createDetector();
    if(!alive){local.close();return;}detector=local;ready=true;clearTimeout(timeout);
   }catch{fail("Este navegador no pudo iniciar la detección local. La cámara sigue disponible.");}
  };
  timeout=setTimeout(()=>fail("La detección local no respondió."),30000);
  try{
   worker=new Worker(base+"/presence-worker.js");
   worker.onerror=fallback;
   worker.onmessage=({data})=>{
    if(!alive)return;
    if(data.type==="ready"){ready=true;clearTimeout(timeout);}
    else if(data.type==="error")fallback();
    else if(data.type==="presence")result(data.count);
   };
   worker.postMessage({type:"init"});
  }catch{fallback();}
  let lastFrame=0;
  timer=setInterval(async()=>{
   if(!alive||!ready||busy||document.hidden||!video.current||video.current.readyState<2)return;
   if(performance.now()-lastFrame<(detector?3000:1500))return;
   lastFrame=performance.now();busy=true;
   try{
    if(detector){result(detector.detect(video.current).detections.length);return;}
    const bitmap=await createImageBitmap(video.current,{resizeWidth:320,resizeHeight:240,resizeQuality:"low"});
    if(!alive){bitmap.close();return;}worker.postMessage({type:"frame",bitmap},[bitmap]);
   }catch{busy=false;fail("No se pudo analizar la vista previa en este navegador.");}
  },500);
  return stop;
 },[enabled,camera,video]);
 useEffect(()=>{if(!camera)setEnabled(false);},[camera]);
 return <div className="space-y-2">
  <button className="hud-button" disabled={!camera} onClick={()=>setEnabled(v=>!v)}>{enabled?"Detener detección de personas":"Detectar presencia en esta cámara"}</button>
  <p className="text-xs text-slate-400">Detección local opcional: {presence===null?"sin resultado estable":presence?"posible persona presente":"sin persona detectada"}. Requiere tres lecturas consecutivas. Puede equivocarse; no identifica a nadie ni determina si duerme.</p>
  {error&&<p role="alert" className="text-sm text-amber-300">{error}</p>}
 </div>;
}
